<template>
<div id="header">
<nav class="navbar navbar-default">
  <div class="container-fluid">
    <!-- Brand and toggle get grouped for better mobile display -->
    <div class="navbar-header">
      <button id="button-menu" type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1" aria-expanded="false">
        <span class="sr-only">Toggle navigation</span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
      </button>
      <router-link to="/" tag="a"><img class="navbar-brand" :src="logoblanco"></router-link>
    </div>

    <!-- Collect the nav links, forms, and other content for toggling -->
    <div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
      <ul class="nav navbar-nav navbar-right">
     <li @click=""><router-link  to="/nosotros" tag="a"> {{ state.header.menu1 }} </router-link></li>
      <li><router-link to="/servicios" tag="a">{{ state.header.menu2 }}</router-link></li>
      <li><router-link to="/infraestructura" tag="a">{{ state.header.menu3 }}</router-link></li>
      <li> <router-link to="/destinos" tag="a">{{ state.header.menu4 }}</router-link></li>
            <li><router-link to="/clientes" tag="a">{{ state.header.menu5 }}</router-link></li>
      <li><router-link to="/contacto" tag="a">{{ state.header.menu6 }}</router-link></li>
      <li @click="toggleLang()" style="cursor: pointer;"><a><i class="fa fa-globe" aria-hidden="true"></i>{{ state.header.menu7 }}</a></li>
      </ul>

    </div><!-- /.navbar-collapse -->

  </div><!-- /.container-fluid -->
</nav>

</div>
</template>

<script>
var $ = require('jquery')
export default {
    data(){
        return{
        }
    },
  methods:{
      toggleLang(){
          this.$store.commit('toggleLang')
      }
  },
  components:{
  },
  computed:{
       logoblanco(){
        return require('../assets/logos/logo_santoyo_blanco.png')
      },
      state(){
          return this.$store.state.activeList
      }
  },
  beforeMount(){
      this.$store.state.activeList = this.$store.state.es
      this.state = this.$store.state.es
  },
  mounted(){
    $('li').on('click', function(){
        $('#button-menu').click()
    })
  }
}
</script>

<style lang="scss" scoped>
@import '~varmix';
#header{
     position:fixed; //cambiar por fixed
     width:100%;
     z-index:100;
     background-color:$azul;
    color:white!important;
    border-bottom:1px solid white;

}

.navbar{
         background-color:$azul;
         color:white!important;
             border-radius: 0px!important;
            border: 0px!important;

}
a{
    text-decoration:none;
         color:white!important;
        padding:15px;
            font-weight:bold;

}
.navbar-brand{
    width:200px;
    height:80px;
    margin-top:15px;
    margin-left: 25px!important;

}
li{
    padding:30px 15px;
    z-index:3;
    color:white;
}
.container-nav{
     border-bottom: 1px solid white;
     z-index:1;
     margin-bottom: -1px;
}
li.active{
    color:white;
    text-decoration: none;
    border-bottom: 2px solid $rojo;
    z-index:2;
    padding:35px;
         margin-bottom: -2px;
  }
  a:hover{
      color:red;
  }
.navbar-toggle{
    border:0px solid transparent!important;
    border-color:transparent!important;
    margin-top:26px;
}
.nav>li>a:focus, .nav>li>a:hover{
    text-decoration: none!important;
    background-color: transparent;
}

#header>li>a:focus, .nav>li>a:hover{
    color:$rojo!important;
}
.navbar-default{
    border-color:none!important;
    margin-top:26px;

}
@media screen and (max-width:1200px) {
li{
    padding:30px 0px;
}

.navbar-brand{
    width:120px;
    height:60px;
    margin-left: 5px!important;

}

}

@media screen and (max-width:1000px) {
li{
    padding:10px 0px;
}
}
</style>



// WEBPACK FOOTER //
// header.vue?6e626e30